import React, {Component} from 'react';
import {Button} from 'reactstrap';
import './Finish-paper.scss';
import * as constants from "../../../../const/constants";
import ImgUndergraduation from '../../../../assets/img/common/undraw_Graduation_ktn0.png';

class App extends Component {
    state = {
        mobileView: 0,
        mark: '',
        questions: ''
    };

    componentDidMount() {
        this.screeSizeChecking();
        this.setState({
            mark: localStorage.getItem("Marks"),
            questions: localStorage.getItem("Quiz"),
        })
    }

    screeSizeChecking = () => {
        if (window.innerWidth <= 991) {
            this.setState({
                mobileView: 1
            });
        } else {
            this.setState({
                mobileView: 0
            });
        }
    };

    completeExam = () => {
        localStorage.setItem("presentage", "");
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_EXAM_ROUTE}`);
    };

    render() {
        return (
            <div className={"finish-paper-main"}>
                {
                    this.state.mobileView == 1 ?
                        <div className={"close-icon"}>
                            <p><i class="icofont-close" onClick={this.completeExam}></i></p>
                        </div>
                        :
                        <div className={"close-icon-web"}>
                        </div>
                }

                <div className={"common-wrapper"}>
                    <p className={"first-line"}> You score:</p>
                    <p className={"score-number"}>{this.state.mark}</p>
                    <p>out of {this.state.questions}</p>
                    {
                        this.state.mobileView == 1 ?
                            <img src={ImgUndergraduation} alt="img"/>
                            :
                            null
                    }
                    {
                        this.state.mobileView == 1 ?
                            <Button className={"Continue-btn"} onClick={this.completeExam}>
                                Continue
                            </Button>
                            :
                            <Button className={"Continue-btn-web"} onClick={this.completeExam}>
                                Continue
                            </Button>
                    }
                </div>
            </div>
        );
    }
}

export default App
/* Created By Janitha Prashad Katukenda
 jpk Created on Mon Dec 14 2020
Copyright (c) 2020 Ceyentra Technologies
EDULAB */


